<template>
	<div class="bodily">
		<!-- <h3 class="qjc-fts-16 qjc-ftw-500 qjc-c-dark">產前的體型信息</h3> -->
		<div class="insert-title">產前的體型信息</div>
		
		<el-form
			:model="formData"
			:rules="rules"
			inline
			ref="bodily"
		>
			<el-form-item
				label="身高:"
				label-width="80px"
				prop="height"
			>
				<el-input
					v-model="formData.height"
					placeholder="請輸入"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="體重:"
				label-width="80px"
				prop="weight"
			>
				<el-input
					v-model="formData.weight"
					placeholder="請輸入"
				></el-input>
				kg
			</el-form-item>
			
			<!-- <el-form-item
				label="胸圍:"
				label-width="80px"
				prop="bust"
			>
				<el-input
					v-model="formData.bust"
					placeholder="請輸入"
				></el-input>
				cm
			</el-form-item> -->
			
			<el-form-item
				label="腰圍:"
				label-width="80px"
				prop="waist"
			>
				<el-input
					v-model="formData.waist"
					placeholder="請輸入"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="臀圍:"
				label-width="80px"
				prop="hip"
			>
				<el-input
					v-model="formData.hip"
					placeholder="請輸入"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="體脂率:"
				label-width="80px"
				prop="fat"
			>
				<el-input
					v-model="formData.fat"
					placeholder="請輸入(選填)"
				></el-input>
				%
			</el-form-item>
			
			<!-- <h3 class="qjc-fts-16 qjc-ftw-500 qjc-c-dark">產後的體型信息</h3> -->
			<div class="insert-title margin-top-40" >產後的體型信息</div>
			<el-form-item
				label="孕週數:"
				label-width="80px"
				prop="preweek"
			>
				<el-input
					v-model="formData.preweek"
					placeholder="請輸入"
				></el-input>
				周
			</el-form-item>
			
			<el-form-item
				label="體重:"
				label-width="80px"
				prop="preweight"
			>
				<el-input
					v-model="formData.preweight"
					placeholder="請輸入"
				></el-input>
				kg
			</el-form-item>
			
			<!-- <el-form-item
				label="胸圍:"
				label-width="80px"
				prop="prebust"
			>
				<el-input
					v-model="formData.prebust"
					placeholder="請輸入"
				></el-input>
				cm
			</el-form-item> -->
			
			<el-form-item
				label="腰圍:"
				label-width="80px"
				prop="prewaist"
			>
				<el-input
					v-model="formData.prewaist"
					placeholder="請輸入"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="臀圍:"
				label-width="80px"
				prop="prehip"
			>
				<el-input
					v-model="formData.prehip"
					placeholder="請輸入"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="體脂率:"
				label-width="80px"
				prop="prefat"
			>
				<el-input
					v-model="formData.prefat"
					placeholder="請輸入(選填)"
				></el-input>
				%
			</el-form-item>
			
			<!-- <el-form-item class="qjc-wid-100 qjc-texta-c">
				<el-button @click="next" class="next qjc-fts-16 qjc-ftw-500">下一步</el-button>
				
			</el-form-item> -->
			
		</el-form>
		<div class="footer-btn">
			<el-button @click="handlePrev" class="prev qjc-fts-16 qjc-block">上一步</el-button>
			<el-button @click="next" class="next qjc-fts-16 qjc-block">下一步</el-button>
		</div>
	</div>
</template>

<script>
	let numberInput = function (value) {
		var price = '' + value;
		price = price
		    .replace(/[^\d.]/g, '') // 清除“數字”和“.”以外的字符
		    .replace(/\.{2,}/g, '.') // 只保留第一個. 清除多餘的
		    .replace('.', '$#$')
		    .replace(/\./g, '')
		    .replace('$#$', '.')
		    .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能輸入兩個小數
		if (price.indexOf('.') < 0 && price != '') {
		    // 以上已經過濾，此處控制的是如果沒有小數點，首位不能為類似於 01、02的金額
		    price = parseFloat(price);
		}
		return price
	}
	export default{
		name: "bodilyComplex",
		data() {
			var heightVerify = (rule, value, callback) => {
				if(isNaN(numberInput(value)) || numberInput(value) < 130 || numberInput(value) > 200){
					callback(new Error('身高為130~200'));
				}else{
					callback();
				}
			}
			var weightVerify = (rule, value, callback) => {
				if(isNaN(numberInput(value)) || numberInput(value) < 30 || numberInput(value) > 160){
					callback(new Error('體重為30~160'));
				}else{
					callback();
				}
			}
			// var bustVerify = (rule, value, callback) => {
			// 	if(isNaN(numberInput(value)) || numberInput(value) < 40 || numberInput(value) > 150){
			// 		callback(new Error('胸圍為40~150'));
			// 	}else{
			// 		callback();
			// 	}
			// }
			var waistVerify = (rule, value, callback) => {
				if(isNaN(numberInput(value)) || numberInput(value) < 40 || numberInput(value) > 150){
					callback(new Error('腰圍為40~150'));
				}else{
					callback();
				}
			}
			var hipVerify = (rule, value, callback) => {
				if(value != '') {
					if(isNaN(numberInput(value)) || numberInput(value) < 60 || numberInput(value) > 165){
						callback(new Error('臀圍為60~165'));
					}else{
						callback();
					}
				}
				if(value == '') {
					callback();
				}
				// if(isNaN(value) || value < 60 || value > 165){
				// 	callback(new Error('臀圍為60~165'));
				// }else{
				// 	callback();
				// }
			}
			var fatVerify = (rule, value, callback) => {
				if(value != '') {
					if(isNaN(numberInput(value)) || numberInput(value) && numberInput(value) < 3 || numberInput(value) > 75){
						callback(new Error('體脂率為3~75'));
					}else{
						callback();
					}
				}
				if(value == '') {
					callback();
				}
			}
			
			return {
				rules: {
					// 產前
					height: [
						{ required: true, message: '請填寫您的身高', trigger: 'blur' },
						{ validator: heightVerify, trigger: 'blur' }
					],
					weight: [
						{ required: true, message: '請填寫您的體重', trigger: 'blur' },
						{ validator: weightVerify, trigger: 'blur' }
					],
					// bust: [
					// 	{ required: true, message: '請填寫您的胸圍', trigger: 'blur' },
					// 	{ validator: bustVerify, trigger: 'blur' }
					// ],
					waist: [
						{ required: true, message: '請填寫您的腰圍', trigger: 'blur' },
						{ validator: waistVerify, trigger: 'blur' }
					],
					hip: [
						{ required: false, message: '請填寫您的臀圍', trigger: 'blur' },
						{ validator: hipVerify, trigger: 'blur' }
					],
					fat: [
						{ validator: fatVerify, trigger: 'blur' }
					],
					
					// 產後
					preweek: [
						{ required: true, message: '請填寫您的孕週數', trigger: 'blur' }
					],
					preweight: [
						{ required: true, message: '請填寫您的體重', trigger: 'blur' },
						{ validator: weightVerify, trigger: 'blur' }
					],
					// prebust: [
					// 	{ required: true, message: '請填寫您的胸圍', trigger: 'blur' },
					// 	{ validator: bustVerify, trigger: 'blur' }
					// ],
					prewaist: [
						{ required: true, message: '請填寫您的腰圍', trigger: 'blur' },
						{ validator: waistVerify, trigger: 'blur' }
					],
					prehip: [
						{ required: false, message: '請填寫您的臀圍', trigger: 'blur' },
						{ validator: hipVerify, trigger: 'blur' }
					],
					prefat: [
						{ validator: fatVerify, trigger: 'blur' }
					]
				},
				
			}
		},
		props: ['formData'],
		methods: {
			handlePrev() {
				this.$emit('checkTab', 'Questions');
			},
			//下一步
			next() {
				this.$refs.bodily.validate((isSuc, err) => {
					if(isSuc){
						this.$emit('checkTab', 'Puerpera');
					}
				});
			},
		}
	}
</script>

<style scoped>
	.bodily >>> .el-form-item__label{
		font-size: 14px;
		color: #777F8F;
		padding-right: 0;
		text-align: left;
	}
	.bodily >>> .el-form-item__label{
		font-size: 14px;
		color: #777F8F;
		padding-right: 10px;
		text-align: right;
	}
	.bodily >>> .el-input{
		width: 400px;
		height: 34px;
		line-height: 34px;
	}
	.bodily >>> .el-input input{
		width: 400px;
		height: 34px;
		font-size: 14px;
		line-height: 14px;
		padding: 9px 12px;
	}
	.bodily >>> .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
		display: none;
	}
	.bodily >>> .el-form-item__content{
		font-size: 14px;
	}
</style>
<style lang="scss" scoped>
	.bodily{
		padding-top: 50px;
		.insert-title {
			position: relative;
			font-size: 16px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #293033;
			line-height: 16px;
			padding-bottom: 15px;
			border-bottom: 1px solid #E5E8F5;
			margin-bottom: 32px;
			
			&::before{
				position: absolute;
				left: -24px;
				top: 0;
				content: '';
				width: 4px;
				height: 20px;
				background-color: #6883FB;
			}
		}
		
		.el-form-item{
			// margin: 24px 80px 0 0;
			// min-width: 500px;
			width: 48% !important;
			
			
		}
		.next-form-item {
			margin-right: 0 !important;
		}
		.footer-btn {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 40px;
		}
				
		.next{
			width: 96px;
			height: 34px;
			border-radius: 17px;
			border: none;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #fff;
		}
		.prev {
			width: 96px;
			height: 34px;
			border-radius: 17px;
			border: 1px solid #6883FB;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #6883FB;
			background-color: #fff;
			margin-right: 24px;
		}
		.el-form{
			h3{
				margin-top: 40px;
			}
			
			.el-form-item{
				width: 48%;
				margin: 24px 0 0 0;
				
				&.qjc-wid-100{
					width: 100%;
				}
			}
		}
		
	}
	.margin-top-40 {
		margin-top: 40px;
	}
</style>
